import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { useLanguage } from '../context/LanguageContext';

export const Footer = () => {
  const { language, t } = useLanguage();
  const currentYear = new Date().getFullYear();

  const productLinks = [
    { key: 'howItWorks', path: 'how-it-works' },
    { key: 'pricing', path: 'pricing' },
    { key: 'benchmarks', path: 'benchmarks' },
  ];

  const companyLinks = [
    { key: 'about', path: 'about' },
    { key: 'contact', path: 'contact' },
  ];

  const supportLinks = [
    { label: t.nav.help, href: 'https://drive.processsurge.com/published/help/Welcome.md' },
    { label: t.nav.status, href: 'https://status.processsurge.com/status/main' },
  ];

  const legalLinks = [
    { label: t.footer.terms, path: 'terms' },
    { label: t.footer.privacy, path: 'privacy' },
    { label: t.footer.commercial, path: 'commercial-terms' },
  ];

  return (
    <footer className="bg-slate-950 border-t border-slate-900 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12 mb-12">
          <div className="col-span-1 md:col-span-1">
            <Logo className="h-8 w-auto mb-6" />
            <p className="text-slate-400 text-sm leading-relaxed max-w-xs">
              {language === 'pt'
                ? 'Automação, integração, IA e dados para operações que querem crescer com clareza.'
                : 'Automation, integrations, AI, and data for operations that want to grow with clarity.'}
            </p>
          </div>

          <div>
            <h3 className="text-slate-100 font-semibold mb-6 uppercase tracking-wider text-xs">{t.footer.product}</h3>
            <ul className="space-y-4">
              {productLinks.map((link) => (
                <li key={link.path}>
                  <Link to={`/${language}/${link.path}`} className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                    {t.nav[link.key]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-slate-100 font-semibold mb-6 uppercase tracking-wider text-xs">{t.footer.company}</h3>
            <ul className="space-y-4">
              {companyLinks.map((link) => (
                <li key={link.path}>
                  <Link to={`/${language}/${link.path}`} className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                    {t.nav[link.key]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-slate-100 font-semibold mb-6 uppercase tracking-wider text-xs">
              {language === 'pt' ? 'Suporte' : 'Support'}
            </h3>
            <ul className="space-y-4">
              {supportLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-slate-400 hover:text-cyan-400 transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-slate-100 font-semibold mb-6 uppercase tracking-wider text-xs">{t.footer.legal}</h3>
            <ul className="space-y-4">
              {legalLinks.map((link) => (
                <li key={link.path}>
                  <Link to={`/${language}/${link.path}`} className="text-slate-400 hover:text-cyan-400 transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-900 flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left">
          <div className="text-slate-500 text-xs font-mono">
            <p className="font-bold text-slate-400 uppercase tracking-widest mb-1">ProcessSurge Tecnologia LTDA</p>
            <p>CNPJ: 64.342.437/0001-96 | R. Pais Leme, 215, São Paulo - SP</p>
          </div>
          <p className="text-slate-500 text-xs">© {currentYear} ProcessSurge. {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};
